import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8cb4ee82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "org-select" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Organisation auswählen", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, " Sie sind Mitglied in mehreren Organisationen. Bitte wählen Sie, in welcher Organisation Sie arbeiten möchten. ", -1))
const _hoisted_4 = {
  key: 0,
  class: "switch-error"
}
const _hoisted_5 = {
  key: 1,
  class: "loading"
}
const _hoisted_6 = {
  key: 2,
  class: "load-error"
}
const _hoisted_7 = {
  key: 3,
  class: "card"
}
const _hoisted_8 = { class: "org-table" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_10 = { class: "org-name" }
const _hoisted_11 = {
  key: 0,
  class: "current-badge"
}
const _hoisted_12 = { class: "actions" }
const _hoisted_13 = ["disabled", "onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "empty"
}, "Keine Organisationen gefunden.", -1))
const _hoisted_16 = [
  _hoisted_15
]

import { ref, computed, onMounted } from "vue";
import { store } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectView',
  setup(__props) {

const loading = ref(false);
const loadError = ref<string | null>(null);
const switchingId = ref<string | null>(null);
const switchError = ref<string | null>(null);

const organisations = computed(() => {
  const all = store.getters["organisation/getAllOrganisation"];
  return Array.isArray(all) ? all : [];
});

function isCurrent(org: { organisationId: string }): boolean {
  return store.getters["organisation/getOrganisationId"] === org.organisationId;
}

async function load() {
  loading.value = true;
  loadError.value = null;
  try {
    await store.dispatch("organisation/FETCH_ALL");
  } catch (e) {
    loadError.value = "Organisationen konnten nicht geladen werden.";
  } finally {
    loading.value = false;
  }
}

async function openOrg(org: { organisationId: string; name?: string }) {
  switchingId.value = org.organisationId;
  switchError.value = null;
  try {
    await store.dispatch("organisation/LOAD", org.organisationId);
    // Rolle in der neuen Organisation bestimmen: Admins (OWNER/ADMIN,
    // Superadmins über den Getter) springen direkt in die Verwaltung,
    // alle anderen ins LMS.
    let admin = false;
    try {
      await store.dispatch("permission/LOAD");
      admin = store.getters["permission/isAdmin"];
    } catch (e) {
      // Berechtigungen nicht lesbar → Standardziel LMS
    }
    // Kompletter Reload statt SPA-Navigation: alle Stores (Kurse, Aufgaben,
    // Zuweisungen …) enthalten sonst noch Daten der vorherigen Organisation.
    // Die gewählte Organisation ist in localStorage persistiert.
    window.location.hash = admin ? "#/company" : "#/lms";
    window.location.reload();
  } catch (e) {
    switchError.value = `Organisation „${org.name || org.organisationId}" konnte nicht geöffnet werden.`;
    switchingId.value = null;
  }
}

onMounted(load);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (switchError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(switchError.value), 1))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Organisationen werden geladen …"))
      : (loadError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(loadError.value), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(organisations), (org) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: org.organisationId
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(org.name || "—"), 1),
                      (isCurrent(org))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Aktuell"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_12, [
                      _createElementVNode("button", {
                        class: "btn btn-secondary btn-open",
                        disabled: switchingId.value !== null || isCurrent(org),
                        onClick: ($event: any) => (openOrg(org))
                      }, _toDisplayString(switchingId.value === org.organisationId ? "Wird geöffnet …" : "Öffnen"), 9, _hoisted_13)
                    ])
                  ]))
                }), 128)),
                (_unref(organisations).length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_14, _hoisted_16))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
  ]))
}
}

})